export default __webpack_public_path__ + "static/media/crate-items_v1_3.fec49cff.jpg";